import { Link } from 'react-router-dom'
import { TacticalCard, TacticalCardHeader } from '@/components/ui/TacticalCard'
import { Download, BookOpen, ArrowUpRight } from 'lucide-react'
import { DOCS_URL } from '@/lib/constants'
import VozillaIcon from '@/../resources/build/icon.png'

function getPlatformLabel(): string {
  const platform = navigator.platform.toLowerCase()
  if (platform.includes('win')) return 'Windows'
  if (platform.includes('linux')) return 'Linux'
  if (platform.includes('mac')) return 'macOS'
  return 'Desktop'
}

export function QuickLinks() {
  const platformLabel = getPlatformLabel()

  return (
    <TacticalCard variant="default" padding="default">
      <TacticalCardHeader className="mb-6">Quick Links</TacticalCardHeader>
      <div className="space-y-4">
        <div className="flex items-center gap-3">
          <img src={VozillaIcon} alt="Vozilla" className="h-10 w-10" />
          <Link
            to="/downloads"
            className="group flex items-center justify-center gap-2 flex-1 px-4 py-2.5 rounded border border-primary/40 text-primary text-sm font-medium hover:bg-primary/10 transition-colors"
          >
            Download for {platformLabel}
            <Download className="h-4 w-4" />
          </Link>
        </div>
        
        <div className="pt-4 mt-2 border-t border-border/50">
          <a
            href={DOCS_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="group flex items-center gap-3 px-3 py-2 -mx-3 rounded text-muted-foreground hover:text-foreground hover:bg-secondary/50 transition-colors"
          >
            <BookOpen className="h-4 w-4" />
            <span className="flex-1 text-sm">Documentation</span>
            <ArrowUpRight className="h-4 w-4" />
          </a>
        </div>
      </div>
    </TacticalCard>
  )
}
